"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgramStatus = void 0;
var ProgramStatus;
(function (ProgramStatus) {
    ProgramStatus[ProgramStatus["Active"] = 1] = "Active";
    ProgramStatus[ProgramStatus["Inactive"] = 2] = "Inactive";
    ProgramStatus[ProgramStatus["Completed"] = 3] = "Completed";
})(ProgramStatus = exports.ProgramStatus || (exports.ProgramStatus = {}));
//# sourceMappingURL=ProgramStatus.js.map